import equals from "fast-deep-equal";

class CamplaLernstickBridgeService {

    static getInstance(){
        if (typeof CamplaLernstickBridgeService.instance === "undefined"){
            return new CamplaLernstickBridgeService();
        }else{
            return CamplaLernstickBridgeService.instance;
        }
    }

    constructor(){
        if (!!CamplaLernstickBridgeService.instance) {
            return CamplaLernstickBridgeService.instance;
        }

        CamplaLernstickBridgeService.instance = this;

        this.currentStatus = null;
        this.currentExamination = null;
        this.currentHardware = null;
        this.stagingChallenge = null;
        this.listeners = [];
        this.examinations = [];
        this.samplingInterval = 500;
        this.health = null;

        this.addListener = this.addListener.bind(this);
        this.hasHardware = this.hasHardware.bind(this);
        this.hasExamination = this.hasExamination.bind(this);
        this.getRunningExamination = this.getRunningExamination.bind(this);
        this.getWifiObject = this.getWifiObject.bind(this);
        this.getRemoteAttestationObject = this.getRemoteAttestationObject.bind(this);
        this.getBatteriesArray = this.getBatteriesArray.bind(this);
        this.generateQRCodeContent = this.generateQRCodeContent.bind(this);
        this.getUSBObject = this.getUSBObject.bind(this);
        this.getSystemObject = this.getSystemObject.bind(this);
        this.getLinkQuality = this.getLinkQuality.bind(this);
        this.isACConnected = this.isACConnected.bind(this);
        this.hasCAMPLAAddon = this.hasCAMPLAAddon.bind(this);

        this._init = this._init.bind(this);
        this._hardwareStatusExists = this._hardwareStatusExists.bind(this);
        this._examinationStatusExists = this._examinationStatusExists.bind(this);

        this._init();

        return this;
    }

    hasHardware(){
        return this.currentHardware !== null;
    }

    hasExamination(){
        return this.currentExamination !== null
            && typeof this.currentExamination.hasConfig !== "undefined"
            && typeof this.currentExamination.isRunning !== "undefined"
            && (this.currentExamination.hasConfig || this.currentExamination.isRunning);
    }

    setStagingChallenge(stagingChallenge){
        this.stagingChallenge = stagingChallenge;
    }

    setExaminations(examinations){
        this.examinations = examinations;
    }

    generateQRCodeContent(){
        const usbSerial = this.getUSBObject() && this.getUSBObject().serial.length > 0
            ? this.getUSBObject().serial : "";

        const instanceId = this.getRunningExamination()
            ? this.getRunningExamination().instanceId : "";

        return JSON.stringify({
            i: instanceId,
            s: usbSerial,
            t: this.stagingChallenge
        });
    }

    getRunningExamination(){
        return (this.currentExamination !== null) ? Object.assign({}, this.currentExamination) : null;
    }

    getSerial(){
        return (this.currentHardware !== null) ? this.currentHardware.hardware.serial : "";
    }

    getUSBObject(){
        return (this.currentHardware !== null) ? Object.assign({}, this.currentHardware.usb) : null;
    }

    getSystemObject(){
        return (this.currentHardware !== null) ? Object.assign({}, this.currentHardware.hardware.system) : null;
    }

    getWifiObject(){
        return (this.currentHardware !== null) ? Object.assign({}, this.currentHardware.wifi) : null;
    }

    isACConnected(){
        return (this.currentHardware !== null) ? this.currentHardware.acConnected : false;
    }

    getBatteriesArray(){
        return (this.currentHardware !== null) ? this.currentHardware.batteries : [];
    }

    getLinkQuality(){
        return (this.currentHardware !== null) ? Math.floor(this.currentHardware.wifi.quality) : 100.0;
    }

    getRAToken(){
        return (this.currentHardware !== null
            && this.currentHardware.raToken
            && this.currentHardware.raToken.length > 0) ? this.currentHardware.raToken : null;
    }

    getRemoteAttestationObject(){
        return (this.currentHardware !== null) ? Object.assign({}, this.currentHardware.hardware.remoteAttestation) : null;
    }

    hasCAMPLAAddon(){
        return sessionStorage.getItem("AddonStatus") !== null;
    }

    addListener(l){
        this.listeners.push(l);
    }

    _examinationStatusExists(){
        return this.currentStatus
            && typeof this.currentStatus.examination !== "undefined"
            && typeof this.currentStatus.examination.examType !== "undefined"
            && typeof this.currentStatus.examination.isRunning !== "undefined"
            && typeof this.currentStatus.examination.instanceId !== "undefined"
            && typeof this.currentStatus.examination.hasConfig !== "undefined";
    }

    _hardwareStatusExists(){
        return this.currentStatus
            && typeof this.currentStatus.hardware !== "undefined"
            && typeof this.currentStatus.hardware.hardwareStatus !== "undefined"
            && this.currentStatus.hardware.hardwareStatus !== null
            && typeof this.currentStatus.hardware.hardwareStatus !== "undefined"
            && typeof this.currentStatus.hardware.hardwareStatus.wifi !== "undefined"
            && typeof this.currentStatus.hardware.hardwareStatus.batteries !== "undefined"
            && typeof this.currentStatus.hardware.hardwareStatus.usb !== "undefined"
            && typeof this.currentStatus.hardware.hardwareStatus.hardware.system !== "undefined"
            && typeof this.currentStatus.hardware.hardwareStatus.hardware.remoteAttestation !== "undefined";
    }

    _init(){
        setInterval(async () => {
            const newStatusString = sessionStorage.getItem("AddonStatus");
            if (newStatusString){
                try {
                    const newStatus = JSON.parse(newStatusString);
                    if (!equals(newStatus, this.currentStatus)){
                        this.currentStatus = Object.assign({}, newStatus);
                        if (this._examinationStatusExists)
                            this.currentExamination = Object.assign({}, this.currentStatus.examination);
                        if (this._hardwareStatusExists())
                            this.currentHardware = Object.assign({}, this.currentStatus.hardware.hardwareStatus);
                        this.listeners.forEach(l => l(this))
                    }
                }catch (err){
                    console.error("Invalid JSON was provided by the addon");
                    console.error(err);
                    console.log(newStatusString);
                }
            }
        }, this.samplingInterval);
    }
}

export default CamplaLernstickBridgeService;
